import script from "./LoadingSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./LoadingSkeleton.vue?vue&type=style&index=0&id=9777d2f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9777d2f6"]])

export default __exports__